import { header } from './modules/header';
import { phoneMaskHandler } from './modules/phone-mask';
import { popupHandler } from './modules/popup';
import { reviewsSlider } from './modules/reviews-slider';
import { servicesAccordion } from './modules/services-accordion';
import { tenDaysAccordion } from './modules/ten-days-accordion';
import { auditTabs } from './modules/audit-tabs';
import { designSlider } from './modules/design-slider';
import { blogSlider } from './modules/blog-slider';
import { smoothScroll } from './modules/smooth-scroll';
import { blogFilters } from './modules/blog-filters';
import { filtersMenu } from './modules/filters-menu';
import { authorPosts } from './modules/author-posts';
import { authorAccordion } from './modules/author-accordion';
import { tableDragScroll } from './modules/table-drag';
import { categoryTopSlider } from './modules/category-top-slider';

import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

window.addEventListener('load', () => {
  
  header();
  phoneMaskHandler();
  popupHandler();
  reviewsSlider();
  servicesAccordion();
  tenDaysAccordion();
  auditTabs();
  designSlider();
  blogSlider();
  smoothScroll();
  blogFilters();
  filtersMenu();
  authorPosts();
  authorAccordion();
  tableDragScroll();
  categoryTopSlider();
})